// Meta Pixel utility
// Pixel ID: 1666692734460053

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '1511203950375437'
let initialized = false

export function initPixel() {
  if (typeof window === 'undefined' || initialized) return

  // Set up the fbq queue stub (same logic as Meta's official snippet,
  // but with a safer DOM insertion that doesn't rely on an existing <script> tag).
  if (!window.fbq) {
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    window.fbq = n
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    // Safely inject the fbevents script into <head>
    const head = document.head || document.getElementsByTagName('head')[0]
    if (head) {
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      head.appendChild(script)
    }
  }

  window.fbq('init', PIXEL_ID)
  initialized = true
}

export function trackPageView() {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

export function trackAddToCart(params?: {
  value?: number
  currency?: string
  content_name?: string
}) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    value: params?.value ?? 14.97,
    currency: params?.currency ?? 'USD',
    content_name: params?.content_name ?? 'El Reset Metabólico 40+',
  })
}
